import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import { Snake } from 'react-snake-lib';

function App() {
  const [noWall, setNoWall] = useState(false);
  const [score, setScore] = useState(0);
  function onScoreChange(score) {
    setScore(score);
  }
  return (
    <div style={{ display: "flex", alignItems: "center", height: "100vh", flexDirection: "column", backgroundColor: "wheat" }} className="App">
      <div style={{ fontSize: "32px", fontWeight: "700", color: "#3e3e3e", marginTop: "55px", marginBottom: "20px" }} >Snake Game</div>
      <Snake
        onScoreChange={onScoreChange}
        width="500px"
        height="500px"
        bgColor="silver"
        innerBorderColor="#b1b0b0"
        snakeSpeed={90}
        size={16}
        startButtonStyle={{
          color: "white",
          padding: "6px 20px",
          backgroundColor: "#1a1a1a",
          borderRadius: "10px",
          fontSize: "17px",
          fontWeight: "600",
          cursor: "pointer"
        }}
        startButtonHoverStyle={{
          backgroundColor: "#4f4d4d"
        }}
        noWall={noWall}
      />
      <div style={{ fontSize: "22px", fontWeight: "700", color: "#3e3e3e", marginTop: "10px" }}>Score: <span style={{ color: "gray" }}>{score}</span></div>
      <div style={{ fontSize: "16px", fontWeight: "700", color: "#3e3e3e", marginTop: "10px", marginBottom: "5px" }}>Set noWall: <span style={{ color: "gray" }}>{JSON.stringify(noWall)}</span> <button className='button' onClick={() => setNoWall(!noWall)}>Change</button></div>
      <div style={{ fontSize: "15px", fontWeight: "700", color: "#3e3e3e", marginTop: "auto", marginBottom: "5px" }}>Created by <span style={{ color: "gray" }}>Ataberk Tümay</span></div>
    </div>
  );
}

export default App;
